/*
 * @Author: tangke
 * @Date: 2019-02-22 16:07:54
 * @Last Modified by: others
 * @Last Modified time: 2019-03-07 16:07:21
 * @课程详情页面
 */
 <template>
 <div class="common-container">
    <v-layout column>
      <loading
        :active="loading"
        :is-full-page="false"
      ></loading>

      <detail-header :roomid ="info.roomid" :LessonStatus="info.LessonStatus" :clid="info.CLID" :classTime="info.ClassTime" class="mt-2"></detail-header>
      <info-table class="mt-3" ref="infoTable"></info-table>
      <!-- 小小外交官 -->
      <!-- <textbook-score v-if="(info.IsShowScore && info.ActivityType==1)"></textbook-score> -->
      <!-- 千万学生开口 -->
      <!-- <millions-students-activity v-if="(info.IsShowScore && info.ActivityType==2)"></millions-students-activity> -->
      <!-- 口语测评 -->
      <oral-class v-if="info.IsAboutSpoken"></oral-class>
      <div>
        <loading
          :active="loadingMaterials"
          :is-full-page="false"
        ></loading>
        <classDCalendar
          class="mt-5"
          v-if="hasMaterials"
        />
      </div>

    </v-layout>
 </div>
</template>
<script>
import detailHeader from './header'
import infoTable from './infoTable'
import classDCalendar from './classDetailCalendar'
// import textbookScore from './textbookScore'
// import millionsStudentsActivity from './millionsStudentsActivity'
import oralClass from './oralClass'
import { createNamespacedHelpers } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

const namespace = 'classDetail'
const { mapGetters, mapActions } = createNamespacedHelpers(namespace)
export default {
  name: 'classDetail',
  data: () => ({

  }),
  components: {
    detailHeader,
    classDCalendar,
    infoTable,
    Loading,
    // textbookScore,
    // millionsStudentsActivity,
    oralClass
  },
  async mounted () {
    let classDetail = await this.fetchInfo(this.$route.params.id)

    let diver = await this.hasDiverUser()
    
    if (this.hasMaterials) {
      this.fetchMeterials()
    }
  },
  computed: {
    ...mapGetters(['loading', 'loadingMaterials', 'hasMaterials', 'info'])
  },
  methods: {
    ...mapActions(['fetchInfo', 'fetchMeterials','hasDiverUser'])
  }

}
</script>
<style lang="scss" scoped>
@import "./classDetail";
</style>
